module.exports = __webpack_public_path__ + "img/op_fondo-cta-empresas.94b9017.jpg";